import { addToCart, serializeForm } from 'lib-utils';


// Size Guide

document.addEventListener('DOMContentLoaded', () => {

  const $forms = Array.from(document.querySelectorAll('.js-product-form'));

  const SELECTORS = {
    sizeGuideButton: '.js-product-sizeguide__button',
    sizeGuide: '.js-size-guide',
  };
  const $sizeGuideButton = document.querySelector(SELECTORS.sizeGuideButton);
  const $sizeGuide = document.querySelector(SELECTORS.sizeGuide);
  const $sizeGuidePage = document.querySelector('.js-product-sizeguide__page');

  if ($forms.length) {
    for (const $form of $forms) {
      const $submitButton = $form.querySelector('[type="submit"]');
      const formId = $form.getAttribute('id');
      const $quantityInput = document.querySelector(
        `nova-quantity-input[data-form-id="${formId}"]`
      );
      $form.addEventListener('submit', (event) => {

        event.preventDefault();

        $submitButton.setAttribute('disabled', true);
        $submitButton.classList.add('loading');

        const formData = JSON.parse(serializeForm($form));
        formData['quantity'] = $quantityInput.value;

        addToCart(formData).then(() => {

          $submitButton.removeAttribute('disabled');
          $submitButton.classList.remove('loading');
        });
      });
    }
  }

  const toggleSizeGuide = () => {
    document.dispatchEvent(new CustomEvent('nova:size-guide:toggle'));
  };

  if ($sizeGuideButton) {
    $sizeGuideButton.addEventListener('click', () => {
      toggleSizeGuide();
    });
  }

  // Only attach events if $sizeGuide exists
  if ($sizeGuide) {
    document.addEventListener('nova:size-guide:toggle', () => {
      document.querySelector('html').classList.toggle('no-scroll');
      if ($sizeGuide.open) {
        $sizeGuide.close();
      } else {
        $sizeGuide.show();
      }
    });

    // TODO: Remove this event listener if no longer needed.
    $sizeGuide.addEventListener('sl-hide', () => {
      document.querySelector('html').classList.toggle('no-scroll');
    });
  }

  if ($sizeGuidePage) {
    const $tables = Array.from($sizeGuidePage.querySelectorAll('table'));
    for (const table of $tables) {
      const $rows = Array.from(table.querySelectorAll('tr'));
      if ($rows.length > 1) {
        table.classList.add('js-table-multiple-rows');
      } else {
        table.classList.add('js-table-single-row');
      }

      const scrollBar = document.createElement('div');
      scrollBar.classList.add('js-size-guide__table-scrollbar');
      table.parentElement.insertBefore(scrollBar, table.nextSibling);

      if (table.scrollWidth === table.clientWidth) {
        scrollBar.classList.add('hidden');
      } else {
        scrollBar.classList.remove('hidden');
      }

      const updateScrollBar = () => {
        const progress =
          ((table.scrollLeft + table.clientWidth) / table.scrollWidth) * 100;

        scrollBar.style.background = `linear-gradient(to right, var(--nova-utility-grey-4, #4b4b4b) ${progress}%, var(--nova-color-grey, #efefed) ${progress}%)`;
      };

      updateScrollBar();

      window.addEventListener('nova:resize-width', () => {
        updateScrollBar();
        if (table.scrollWidth === table.clientWidth) {
          scrollBar.classList.add('hidden');
        } else {
          scrollBar.classList.remove('hidden');
        }
      });

      table.addEventListener('scroll', updateScrollBar);
    }
  }

  const swiperCompatible = new Swiper('.swiper-compatible-with-container', {
    slidesPerView: 2,
    slidesPerGroup: 2,
    navigation: {
      nextEl: '.button-next',
      prevEl: '.button-prev',
    },
    spaceBetween: 20,
    mousewheel: true,
    // loop: true,
    breakpoints: {
      768: {
        spaceBetween: 20,

        slidesPerView: 3,
      },
      840: {
        slidesPerView: 2.3, spaceBetween: 12,

        draggable: false
      },
    },
  });


});



// Product Slider

function getMainSliderSettings(thumbsSwiper) {

  return {
    loop: false,
    spaceBetween: 16,
    zoom: true,
    maxRatio: 1,
    slidesPerView: 1.6,
    grid: { rows: 0 },
    panOnMouseMove: true,
    breakpoints: {
      640: {
        slidesPerView: 1.7,

      },
      768: {
        slidesPerView: 2.5,
        grid: { rows: 0 },
      },
      990: {
        slidesPerView: 2,
        grid: { rows: 12, fill: "row" },
      },
    },
    thumbs: { swiper: thumbsSwiper },
  };
}

// Returns configuration settings for the thumbs slider.
function getThumbsSliderSettings() {
  console.debug("Generating thumbs slider settings");
  return {
    loop: false,
    spaceBetween: 8,
    slidesPerView: "auto",
    freeMode: true,
    watchSlidesProgress: true,
  };
}

// Generic initializer for a Swiper slider.
function initSwiperSlider(sliderEl, config) {
  if (!sliderEl) {
    return null;
  }
  return new Swiper(sliderEl, config);
}

// Initializes the default sliders that are visible on the page.
// It finds the main slider and its corresponding thumbs slider that do not have the .hidden class.
function initializeDefaultSliders() {
  const mainEl = document.querySelector(".product-slider__main:not(.hidden)");
  const thumbsEl = document.querySelector(".product-slider__thumbs:not(.hidden)");

  if (mainEl && thumbsEl) {
    console.debug("Default sliders found. Main:", mainEl, "Thumbs:", thumbsEl);
    const thumbsSwiper = initSwiperSlider(thumbsEl, getThumbsSliderSettings());
    const mainSwiper = initSwiperSlider(mainEl, getMainSliderSettings(thumbsSwiper));


    return { mainSwiper, thumbsSwiper };

  } else {
    console.warn("Default visible sliders not found.");
    return null;
  }
}

// Initializes sliders based on the provided data handle.
function initializeSlidersForHandle(handle) {

  const sliderMain = document.querySelector(`.product-slider__main[data-slider="${handle}"]`);
  if (!sliderMain) {
    console.warn("No main slider found for handle:", handle);
    return;
  }
  const sliderThumbs = document.querySelector(`.product-slider__thumbs[data-slider="thumbs-${handle}"]`);

  // Hide all main and thumbs sliders.
  document.querySelectorAll(".product-slider__main").forEach(slider => slider.classList.add("hidden"));
  document.querySelectorAll(".product-slider__thumbs").forEach(slider => slider.classList.add("hidden"));

  // Show the target sliders.
  sliderMain.classList.remove("hidden");
  if (sliderThumbs) {
    sliderThumbs.classList.remove("hidden");
  }

  // Initialize thumbs slider first.
  const thumbsSwiper = sliderThumbs ? initSwiperSlider(sliderThumbs, getThumbsSliderSettings()) : null;
  // Initialize main slider with the thumbsSwiper instance.
  initSwiperSlider(sliderMain, getMainSliderSettings(thumbsSwiper));
}

// On DOM load, initialize default sliders and attach event listeners to swatch inputs.
document.addEventListener("DOMContentLoaded", function () {

  initializeDefaultSliders();

  // Attach event listeners for all swatch inputs.
  document.querySelectorAll(".vp__input--color input").forEach(input => {
    input.addEventListener("click", function (e) {
      const handle = e.target.getAttribute("data-handle");

      // Check if a corresponding main slider exists.
      if (document.querySelector(`.product-slider__main[data-slider="${handle}"]`)) {

        initializeSlidersForHandle(handle);
      } else {
        console.debug("No corresponding slider for handle:", handle, ". No action taken.");
      }
    });
  });
});
// remove loading
const $loadingElements = document.querySelectorAll('.loading');
if ($loadingElements.length) {
  setTimeout(() => {
    $loadingElements.forEach($loading => $loading.classList.remove('loading'));
  }, 2000);
}


// Klarna translations
function detectLanguageFromUrl() {
  const lang = window.location.pathname.split('/')[1]
  const supportedLangs = ['fr', 'de', 'nl']
  return supportedLangs.includes(lang) ? lang : null
}

function translateKlarnaText(originalText, lang) {
  const amountMatch = originalText.match(/\$([\d.]+)/)
  if (!amountMatch) return null

  const amount = amountMatch[1]

  const templates = {
    fr: `À partir de ${amount} $/mois ou 4 paiements sans intérêts avec Klarna`,
    de: `Ab ${amount} $/Monat oder 4 zinsfreie Raten mit Klarna`,
    nl: `Vanaf ${amount} $/maand of 4 renteloze betalingen met Klarna`,
  }

  return templates[lang] || originalText
}

function waitForShadowContent(hostSelector, innerSelector, callback) {
  const observer = new MutationObserver((_, obs) => {
    const host = document.querySelector(hostSelector)
    if (!host?.shadowRoot) return

    const target = host.shadowRoot.querySelector(innerSelector)
    if (!target) return

    obs.disconnect()
    callback(target)
  })

  observer.observe(document.body, { childList: true, subtree: true })
}

function applyKlarnaTranslationIfNeeded() {
  const lang = detectLanguageFromUrl()
  if (!lang) return

  waitForShadowContent('klarna-placement', '.text-wrapper p', (element) => {
    const contentObserver = new MutationObserver((_, obs) => {
      const rawText = element.textContent.trim()
      const button = element.querySelector('button')

      if (!rawText || !button?.textContent.trim()) return

      const translated = translateKlarnaText(rawText, lang)
      if (!translated) {
        console.warn('⚠️ Could not extract amount from Klarna text.')
        obs.disconnect()
        return
      }

      const textNode = Array.from(element.childNodes).find(
        (n) => n.nodeType === Node.TEXT_NODE && n.textContent.trim()
      )
      if (textNode) textNode.textContent = translated

      button.textContent =
        {
          fr: 'En savoir plus',
          de: 'Mehr erfahren',
          nl: 'Meer informatie',
        }[lang] || 'Learn more'

      console.log(`✅ Klarna text translated to "${lang}".`)
      obs.disconnect()
    })

    contentObserver.observe(element, {
      childList: true,
      characterData: true,
      subtree: true,
    })
  })
}

// 🔁 Auto-run on page load
applyKlarnaTranslationIfNeeded()
